import { getUserStoreInfo } from 'utils/authService'

export interface AuthorizationData {
  expeditorEnvironmentAuthorizationNumber: string
  expeditorEnvironmentAuthorizationExpirationDate: string
}

const useExpeditorAuthorizationData = () => {
  const currentStore = getUserStoreInfo()

  const setAuthorizationData = (data: AuthorizationData) => {
    localStorage.setItem(
      `environmentalAuthorizationNo-${currentStore.storeADId}`,
      data.expeditorEnvironmentAuthorizationNumber
    )
    localStorage.setItem(
      `environmentalPermitExpirationDate-${currentStore.storeADId}`,
      data.expeditorEnvironmentAuthorizationExpirationDate
    )
  }

  const getAuthorizationData = (): AuthorizationData => ({
    expeditorEnvironmentAuthorizationNumber: localStorage.getItem(
      `environmentalAuthorizationNo-${currentStore.storeADId}`
    ),
    expeditorEnvironmentAuthorizationExpirationDate: localStorage.getItem(
      `environmentalPermitExpirationDate-${currentStore.storeADId}`
    )
  })

  return { setAuthorizationData, getAuthorizationData }
}

export default useExpeditorAuthorizationData
